import { render, staticRenderFns } from "./GreetPost.vue?vue&type=template&id=af76cac2&scoped=true"
import script from "./GreetPost.vue?vue&type=script&lang=js"
export * from "./GreetPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af76cac2",
  null
  
)

export default component.exports